import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { MuiMarkdown_V2 } from "../../../Shared/components/MuiMarkdown/MuiMarkdown_V2";
import { useOpenBalanceContext } from "../context/OpenBalanceContext";
import { OpenBalanceTexts } from "../utils/openBalance-enums";
export const PastCutoffMessage = () => {
    const { pastCutoffMarkdown } = useOpenBalanceContext();
    if (!pastCutoffMarkdown) {
        return _jsx(Typography, Object.assign({ variant: "h2" }, { children: OpenBalanceTexts.DEFAULT_PAST_CUTOFF }));
    }
    return _jsx(MuiMarkdown_V2, { children: pastCutoffMarkdown });
};
